import React from "react";
import dateFns from "date-fns";
import es from "date-fns/locale/es";

interface CalendarMonthsProps {
  newDate: Date;
  showMonths: boolean;
  isAllowSelect: (clickedDate: Date, monthSearch?: boolean) => boolean;
  onClickDate: (clickedDate: Date, close: boolean, forceDate?: boolean) => void;
  minDate?: string;
  maxDate?: string;
}

const CalendarMonths = ({
  newDate,
  showMonths,
  isAllowSelect,
  onClickDate,
}: CalendarMonthsProps) => {
  let tempDate = dateFns.setMonth(new Date(), 0);
  let rows = [];
  let months = [];

  for (let i = 0; i < 12; i++) {
    const monthDate = dateFns.setMonth(newDate, i);
    months.push(
      <div
        className={`select-month-container-item ${
          !isAllowSelect(monthDate, true) ? "no-allow" : ""
        }`}
        key={i}
        onClick={() => {
          const selected = dateFns.setMonth(newDate, i);
          onClickDate(selected, false, true);
        }}
      >
        <p>{dateFns.format(tempDate, "MMMM", { locale: es })}</p>
      </div>
    );
    tempDate = dateFns.addMonths(tempDate, 1);

    if ((i + 1) % 3 === 0) {
      rows.push(
        <div className="select-month-container-row" key={i}>
          {months}
        </div>
      );
      months = [];
    }
  }

  return <div className={"select-month-container " + (showMonths ? "active" : "")}>{rows}</div>;
};

export default CalendarMonths;
